import { Component } from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {Location} from "@angular/common";
import {ApiServiceService} from "../../../../Services/api-service.service";
import {AuthService} from "../../../../Services/auth.service";
import * as moment from "moment/moment";
import alertify from "alertifyjs";

@Component({
  selector: 'app-payment-reconciliation',
  templateUrl: './payment-reconciliation.component.html',
  styleUrls: ['./payment-reconciliation.component.css']
})
export class PaymentReconciliationComponent {
  isEmpty: boolean = false;
  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  details: any;
  isLoading: any;
  isSearching: any;
  count: number = 0;
  pageSize: number = 5;
  searchForm: any = FormGroup;
  showSearch: boolean = false;
  tempRevenueType: string;
  selectedOutput: any;
  countDetails: any;
  searchInstruction: boolean;
  showFilters = false;
  minDate: any;



  constructor(
      private location: Location,
      private fb: FormBuilder,
      private apiService: ApiServiceService,
      private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      category: [""],
      mdaRecordId: [""],
      revenueType: [""],
      from: [""],
      to: [""],
      feeDescription: [""],
      rrr: [""],
      mdaName: [""],
      offset: [""],
      output: [""],
      paymentStatus: [""],
      paymentChannel: [""],
      asin: [""],
    });

    this.selectedOutput = "all";

    this.searchInstruction = true;

    this.searchForm.get("from")?.valueChanges?.subscribe((v) => {
      this.minDate = v;
      if (this.searchForm?.get("to")?.value) {
        if (moment(v).isAfter(this.searchForm?.get("to")?.value)) {
          this.searchForm?.get("to")?.patchValue(null);
        }
      }
    });
  }

  resetForm() {
    this.searchForm = this.fb.group({
      from: [""],
      to: [""],
      rrr: [""],
      mdaName: [""],
      offset: [""],
        asin:[""]
    });
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  search() {
    this.searchInstruction = false;

    this.details = [];
    this.countDetails = {};

    var formData: any = new FormData();
    this.isEmpty = false;
    this.isSearching = true;

    this.num = this.page * 5;

    formData.append("rrr", this.searchForm.get("rrr").value);
    formData.append("asin", this.searchForm.get("asin").value);
    formData.append("from", this.searchForm.get("from").value !== "" ? moment(this.searchForm.get("from").value).format("YYYY-MM-DD") : "",);
    formData.append("to", this.searchForm.get("to").value !== "" ? moment(this.searchForm.get("to").value).format("YYYY-MM-DD") : "",);
    formData.append("offset", this.num);

      const url = "/api/payment/search-payments";
      this.apiService.paymentPost_(url, formData).subscribe(
          (response) => {
            this.details = response?.results;
            if (this.details.length > 0) {
              this.isLoading = false;
              this.count = Math.ceil(response.total);
              this.isSearching = false;
              this.showFilters = false;
            } else {
              this.isLoading = false;
              this.isSearching = false;
              this.isEmpty = true;
              this.showFilters = false;
            }
          },
          (error) => {
            this.isLoading = false;
            alertify.set("notifier", "position", "top-center");
            alertify.error("Error performing this operation");
            this.isEmpty = true;
            this.isSearching = false;
          },
      );

  }


  goBack() {
    this.location.back();
  }

  downloadPaymentReceipt(rrr: string) {
    let url = "/assessments/print/payment/receipt";

    let dto = {
      rrr: rrr,
    };

    this.apiService.post(url, dto, { responseType: "blob" }).subscribe(
        (response: Blob) => {
          const blob = new Blob([response], { type: "application/pdf" });

          // Create a Blob URL for the PDF content
          const blobUrl = window.URL.createObjectURL(blob);

          // Open PDF in a new tab
          // window.open(blobUrl, '_blank');

          const file = new Blob([response], { type: "application/pdf" });

          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);

          // Optionally, trigger a download by creating an anchor element
          const downloadLink = document.createElement("a");
          downloadLink.href = blobUrl;
          downloadLink.target = "_blank";
          downloadLink.download = "payment_receipt.pdf"; // File name for download

          // Uncomment this line to trigger the download automatically
          downloadLink.click();

          alertify.set("notifier", "position", "top-center");
          alertify.success("Download successful");
        },
        (error) => {
          this.isLoading = false;
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
        },
    );
  }

  toggleFilter(): void {
    this.showFilters = !this.showFilters;
  }

  now(): Date {
    return new Date();
  }

  get minDateValue(): any {
    return this.minDate;
  }

  sendToKafka(eachDetail: any) {
    this.apiService.paymentPost_("/api/payment/send-message?id=" + eachDetail.id, {}).subscribe(value => {
        alertify.set("notifier", "position", "top-center");
        alertify.success("Payment sent to Kafka successfully");
    }, error => {
        console.log(error);
        alertify.set("notifier", "position", "top-center");
        alertify.success("Payment sent to Kafka successfully");
    });
  }

  hasAccess(permissions:string[]){
    return this.authService.hasAnyPermission(permissions)
  }
}
